export const NUMBER_OF_TOTAL_COMPANY_SHARES_GRID_TOOLTIP =
  "numOfTotalCompanyShares";
export const POST_MONEY_GRID_TOOLTIP = "postMoney";
export const TOTAL_VOTES_TOOLTIP = "totalVotes";
export const MY_TOTAL_SHARES_GRID_TOOLTIP = "myTotalShares";
export const MY_SHARES_TOOLTIP = "myShares";
export const INVESTED_AMOUNT_GRID_TOOLTIP = "investedAmount";
